/* eslint-disable react-hooks/exhaustive-deps */
import { useAppDispatch, useModalState } from '@core/configureStore';
import { closeModal, enqueueNotification, integrateToService } from '@core/features';
import { useHeroApiService } from '@core/hooks';
import { FacebookPage } from '@core/models';
import { Button, Modal, Radio, Skeleton, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { LoadableContainer } from '..';

type Props = {};

const SelectFacebookPagesModal = (props: Props) => {
  const dispatch = useAppDispatch();
  const heroApiService = useHeroApiService();
  const [pageList, setPageList] = useState<FacebookPage[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedPageId, setSelectedPageId] = useState<string | undefined>(undefined);
  const { selectFacebookPagesModal } = useModalState();

  const handleCloseModal = () => {
    dispatch(
      closeModal({
        modalName: 'selectFacebookPagesModal',
      })
    );
  };

  const handlePageChanged = (id: string) => {
    setSelectedPageId(id);
  };

  const handleSelectPage = async () => {
    try {
      const selectedPage = pageList.find(page => page.id === selectedPageId);
      if (!selectedPage) return;
      setLoading(true);
      await heroApiService.selectFacebookPage(selectedPage);
      dispatch(
        integrateToService({
          platform: 'facebook_page',
          profile: selectedPage,
        })
      );
      await dispatch(
        enqueueNotification({
          name: 'Page is selected',
          description: 'Select page sucessfully',
          type: 'Success',
        })
      );
      setSelectedPageId(undefined);
    } catch (error) {
      dispatch(
        integrateToService({
          platform: 'facebook_page',
          profile: undefined,
        })
      );
      await dispatch(
        enqueueNotification({
          name: 'Failed to select page',
          description: 'Select page unsucessfully',
          type: 'Error',
        })
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const pages = await heroApiService.getFacebookPages();
      setPageList(pages);
      setLoading(false);
    };
    if (selectFacebookPagesModal) init();
  }, [selectFacebookPagesModal]);

  return (
    <React.Fragment>
      <Modal
        title="Select Facebook Page"
        centered
        open={selectFacebookPagesModal}
        closable
        onCancel={handleCloseModal}
        destroyOnClose
        footer={[
          <Button onClick={handleCloseModal}>Cancel</Button>,
          <Button onClick={handleSelectPage} type="primary" disabled={!selectedPageId}>
            Select
          </Button>,
        ]}>
        <LoadableContainer isLoading={loading} loadComponent={<Skeleton />}>
          <React.Fragment>
            <Radio.Group onChange={e => handlePageChanged(e.target.value)} value={selectedPageId}>
              <Space direction="vertical">
                {pageList.map(page => (
                  <Radio
                    style={{
                      padding: '10px 20px',
                    }}
                    value={page.id}>
                    {page.name}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </React.Fragment>
        </LoadableContainer>
      </Modal>
    </React.Fragment>
  );
};

export default SelectFacebookPagesModal;
